import { useGetEntityComplianceSettingsLazyQuery } from "~/graphql/supergraphHooks";

export function useEntityComplianceProgram() {
  const [getEntity, { loading }] = useGetEntityComplianceSettingsLazyQuery({
    fetchPolicy: "no-cache",
  });

  const getComplianceProgram = async (
    entityId: string,
    name: string,
  ): Promise<string | null> => {
    const result = await getEntity({
      variables: {
        nameSearchTerm: name,
      },
    });
    const rows = result.data?.investmentEntitiesForProgramAssignment?.rows ?? [];
    const row = rows.find((r) => r.id === entityId);
    return row?.complianceSettings?.complianceProgram ?? null;
  };

  const checkComplianceProgram = async (entityId: string, name: string): Promise<boolean> =>
    Boolean(await getComplianceProgram(entityId, name));

  return { checkComplianceProgram, getComplianceProgram, loading };
}
